<template>
  <div class="d-flex" id="wrapper">
    <div id="sidebar-wrapper">
      <ManagerSidebar :toggler.sync="isToggled" profile="getManagerProfile" />
      <!-- Page Content -->
    </div>
    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav" :profile="getManagerUserProfile" />

      <section id="description">
        <div class="row">
          <div class="col-md-8">
            <div class="card custom-card">
              <form ref="updateForm" @submit.prevent="updateJobAd">
                <div class="job-content">
                  <div class="col-md-12">
                    <div class="header-title d-flex">
                      <figure class="candidate-picture" style="margin-bottom: 0">
                        <img
                          v-if="
                            getManagerJobByID.photo !== null &&
                              getManagerJobByID.photo !== 'null' &&
                              getManagerJobByID.photo !== 'default.png'
                          "
                          class="rounded-circle mr-3"
                          :src="
                            `https://jobshark.eu/storage/employers/logos/${getManagerJobByID.photo}`
                          "
                          alt="logo"
                        />
                        <img
                          v-else
                          class="rounded-circle mr-3"
                          src="
                              https://jobshark.eu/img/comstream.svg
                            "
                          alt="logo"
                        />
                      </figure>
                      <div
                        class="header-title-name d-flex align-items-center"
                        v-if="!isInGlobalEditMode"
                      >
                        <b>{{ getManagerJobByID.title }}</b>
                        <span
                          v-if="getManagerJobByID.status !== 1 && getManagerJobByID.status !== 3"
                          class="job-edit ml-2"
                        >
                          <router-link to>
                            <svgHelper
                              @click.native="changeGlobalEditMode"
                              class="job-edit-icon"
                              name="edit"
                            ></svgHelper>
                          </router-link>
                        </span>
                      </div>
                      <div class="d-flex flex-grow-1 name-edit" v-else>
                        <input
                          type="text"
                          class="form-control"
                          id="job_name"
                          placeholder="Title"
                          v-model="selectedJobTitle"
                        />

                        <!-- Btns -->
                        <div
                          class="form-buttons text-right ml-auto w-50"
                          v-show="isInGlobalEditMode"
                        >
                          <button type="submit" class="btn btn-primary mr-2">Save</button>
                          <button class="btn btn-danger" @click="isInGlobalEditMode = false">
                            Cancel
                          </button>
                          <br />
                          <i
                            style="cursor: pointer; font-size: 21px"
                            data-toggle="modal"
                            href="#deleteJobModal"
                            class="fas fa-trash-alt mt-2"
                          ></i>
                        </div>
                      </div>
                      <div v-if="!isInGlobalEditMode" class="d-flex align-items-center">
                        <svgHelper
                          :name="serviceLevel(getManagerJobByID.service_level).title"
                        ></svgHelper>

                        <span
                          class="mr-2 job-type"
                          style="flex: 1; padding-left: 12px; padding-right: 12px"
                          >{{ serviceLevel(getManagerJobByID.service_level).title }}</span
                        >
                        <button
                          @click="jobStatusModalShow = true"
                          v-if="getManagerJobByID.status === 1 || getManagerJobByID.status === 3"
                          type="button"
                          class="btn btn-danger"
                        >
                          Stop Publishing
                        </button>
                        <button
                          type="button"
                          @click="jobStatusModalShow = true"
                          v-else
                          class="btn btn-success"
                        >
                          Publish
                        </button>
                      </div>
                    </div>
                  </div>

                  <nav class="job-controls-tabs">
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <a
                        class="nav-item nav-link active"
                        id="nav-primary-tab"
                        data-toggle="tab"
                        href="#nav-primary"
                        role="tab"
                        aria-controls="nav-primary"
                        aria-selected="true"
                      >
                        PRIMARY</a
                      >
                      <a
                        class="nav-item nav-link"
                        id="nav-requirements-tab"
                        data-toggle="tab"
                        href="#nav-requirements"
                        role="tab"
                        aria-controls="nav-requirements"
                        aria-selected="false"
                      >
                        REQUIREMENTS</a
                      >
                      <a
                        v-if="
                          getManagerJobByID.service_level === 1 ||
                            getManagerJobByID.service_level === 2
                        "
                        class="nav-item nav-link"
                        id="nav-ad-tab"
                        data-toggle="tab"
                        href="#nav-ad"
                        role="tab"
                        aria-controls="nav-ad"
                        aria-selected="false"
                      >
                        JOB AD</a
                      >
                    </div>
                  </nav>
                  <div class="tab-content" id="nav-tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="nav-primary"
                      role="tabpanel"
                      aria-labelledby="nav-primary-tab"
                    >
                      <div class="mobile-clear">
                        <div class="row">
                          <div class="col-md-12">
                            <div
                              class="single-job-controls d-flex align-items-center d-block d-sm-none"
                            >
                              <!-- Add Job btn -->
                              <!--               <button
                                style="right: 14px"
                                type="button"
                                class="btn btn-success text-nowrap ml-3"
                                @click="showModal = true"
                              >
                                Add Job
                                <portal to="add-job-modal">
                                  <CustomMainModal @close="showModal = false" v-show="showModal">
                                    <template v-slot:header>
                                      <h5>Add Job</h5>
                                    </template>
                                    <AddJobBtnModal />
                                  </CustomMainModal>
                                </portal>
                              </button> -->
                            </div>
                          </div>
                          <div class="col-md-12">
                            <ul class="list-group list-group-flush job-details">
                              <div class="row">
                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.cityFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.city = true"
                                    @mouseleave="editFields.city = false"
                                    class="d-flex"
                                  >
                                    <span>Location</span>
                                    <div class="d-flex align-items-center icon-container">
                                      <div
                                        v-if="
                                          getManagerJobByID.status !== 1 &&
                                            getManagerJobByID.status !== 3
                                        "
                                        class="edit-btn"
                                      >
                                        <router-link v-if="editFields.city" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="city"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <div>
                                        {{ getManagerJobByID.city.name }},
                                        {{ getManagerJobByID.country.name }}
                                      </div>
                                    </div>
                                  </div>

                                  <div class="d-flex new-location" v-else>
                                    <span class="mr-0">
                                      <b>Location</b>
                                    </span>
                                    <div class="location-container">
                                      <v-select
                                        class="country-select mr-1"
                                        v-model="selectedCountry"
                                        @input="
                                          fetchCitiesByCountryId($event);
                                          clearCity();
                                        "
                                        label="name"
                                        :options="getAllCountries"
                                        :reduce="country => country"
                                        :clearable="false"
                                      >
                                        <template v-slot:no-options="{ search, searching }">
                                          <template v-if="searching && search.length >= 3">
                                            No results found for <em>{{ search }}</em
                                            >.
                                          </template>
                                          <div style="opacity: 0.5" v-else>
                                            Please type at least 3 characters
                                          </div>
                                        </template>
                                      </v-select>
                                      <v-select
                                        class="city-select"
                                        label="name"
                                        v-model="selectedCity"
                                        :options="getCitiesListByCountry"
                                        :reduce="city => city"
                                        :clearable="false"
                                      >
                                        <template v-slot:no-options>
                                          <div style="opacity: 0.5">
                                            Please select a country first
                                          </div>
                                        </template>
                                      </v-select>
                                    </div>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.cityFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.postalCodeFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.postal = true"
                                    @mouseleave="editFields.postal = false"
                                    class="d-flex"
                                  >
                                    <span>
                                      <b>Postal code</b>
                                    </span>

                                    <div class="custom-control icon-container">
                                      <div
                                        v-if="
                                          getManagerJobByID.status !== 1 &&
                                            getManagerJobByID.status !== 3
                                        "
                                        class="edit-btn"
                                      >
                                        <router-link v-if="editFields.postal" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="postal"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <div v-if="getManagerJobByID && getManagerJobByID.address">
                                        {{ getManagerJobByID.address.postal_code }}
                                      </div>
                                    </div>
                                  </div>

                                  <span class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Postal code</b>
                                    </span>

                                    <input
                                      type="text"
                                      id="postal"
                                      class="form-control"
                                      v-model="selectedPostalCode"
                                    />

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.postalCodeFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </span>
                                </li>

                                <li class="list-group-item col-md-6">
                                  <div
                                    v-if="!editIconState.individualsFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.individuals = true"
                                    @mouseleave="editFields.individuals = false"
                                    class="d-flex"
                                  >
                                    <span>No of individuals</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div
                                        v-if="
                                          getManagerJobByID.status !== 1 &&
                                            getManagerJobByID.status !== 3
                                        "
                                        class="edit-btn"
                                      >
                                        <router-link v-if="editFields.individuals" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="need-individuals"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ getManagerJobByID.individuals_number }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span>No of individuals </span>

                                    <input
                                      type="text"
                                      class="form-control w-100"
                                      v-model="selectedIndividuals"
                                    />

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.individualsFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.employmentFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.employment = true"
                                    @mouseleave="editFields.employment = false"
                                    class="d-flex"
                                  >
                                    <span>Employment</span>
                                    <div class="d-flex align-items-center icon-container">
                                      <div
                                        v-if="
                                          getManagerJobByID.status !== 1 &&
                                            getManagerJobByID.status !== 3
                                        "
                                        class="edit-btn"
                                      >
                                        <router-link v-if="editFields.employment" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="employment"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{
                                        getEmploymentType(getManagerJobByID.employment_type).name
                                      }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Employment</b>
                                    </span>

                                    <select
                                      class="form-control w-100"
                                      style="padding-left: 7px"
                                      v-model="selectedEmploymentType"
                                      id="employment_type"
                                    >
                                      <option :value="1">Employment</option>
                                      <option :value="2">Self-employment</option>
                                      <option :value="3">Employment / Self-Employment</option>
                                    </select>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.employmentFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6">
                                  <div
                                    v-if="!editIconState.durationFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.duration = true"
                                    @mouseleave="editFields.duration = false"
                                    class="d-flex"
                                  >
                                    <span>Duration </span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div
                                        v-if="
                                          getManagerJobByID.status !== 1 &&
                                            getManagerJobByID.status !== 3
                                        "
                                        class="edit-btn"
                                      >
                                        <router-link v-if="editFields.duration" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="duration"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ calculateDuration(getManagerJobByID.duration) }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span>Duration</span>

                                    <select
                                      v-if="getManagerJobByID.service_level !== 4"
                                      id="full-time"
                                      v-model="selectedDuration"
                                      class="form-select w-100"
                                    >
                                      <option value="1">Permanent employment</option>
                                      <option value="2">Time-limited employment</option>
                                    </select>
                                    <select
                                      v-else
                                      id="full-time"
                                      v-model="selectedDuration"
                                      class="form-select w-100"
                                    >
                                      <option value="3">Less than 1 month</option>
                                      <option value="4">1-3 months</option>
                                      <option value="5">3-6 months</option>
                                      <option value="6">6-12 months</option>
                                      <option value="7">More than 12 months</option>
                                    </select>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.durationFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>
                                <li class="list-group-item col-md-6">
                                  <div
                                    v-if="!editIconState.fullTimeFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.fullTime = true"
                                    @mouseleave="editFields.fullTime = false"
                                    class="d-flex"
                                  >
                                    <span>Full-time</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div
                                        v-if="
                                          getManagerJobByID.status !== 1 &&
                                            getManagerJobByID.status !== 3
                                        "
                                        class="edit-btn"
                                      >
                                        <router-link v-if="editFields.fullTime" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="fullTime"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ getManagerJobByID.full_time ? 'Yes' : 'No' }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span>Full time</span>

                                    <select
                                      class="form-control w-100"
                                      v-model="selectedFullTime"
                                      style="box-shadow: none"
                                    >
                                      <option :value="true">Yes</option>
                                      <option :value="false">No</option>
                                    </select>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.fullTimeFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6">
                                  <div
                                    v-if="!editIconState.workplaceFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.workplace = true"
                                    @mouseleave="editFields.workplace = false"
                                    class="d-flex"
                                  >
                                    <span>Workplace</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div
                                        v-if="
                                          getManagerJobByID.status !== 1 &&
                                            getManagerJobByID.status !== 3
                                        "
                                        class="edit-btn"
                                      >
                                        <router-link v-if="editFields.workplace" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="workplace"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ showWorkPlace(getManagerJobByID.workplace) }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span>Workplace</span>
                                    <select
                                      class="form-control w-100"
                                      v-model="selectedWorkplace"
                                      style="box-shadow: none"
                                    >
                                      <option value="1">Onsite</option>
                                      <option value="2">Hybrid</option>
                                      <option value="3">Remote</option>
                                    </select>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.workplaceFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.relocationFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.relocation = true"
                                    @mouseleave="editFields.relocation = false"
                                    class="d-flex"
                                  >
                                    <span>
                                      <b>Relocation</b>
                                    </span>
                                    <div class="custom-control icon-container">
                                      <div
                                        v-if="
                                          getManagerJobByID.status !== 1 &&
                                            getManagerJobByID.status !== 3
                                        "
                                        class="edit-btn"
                                      >
                                        <router-link v-if="editFields.relocation" to>
                                          <i
                                            @click="showEditForm($event)"
                                            id="relocation"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <span style="font-weight: 400">{{
                                        getManagerJobByID.relocation ? 'Yes' : 'No'
                                      }}</span>
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Relocation</b>
                                    </span>

                                    <div class="custom-control custom-checkbox">
                                      <input
                                        id="promoted-checkbox"
                                        class="custom-control-input"
                                        type="checkbox"
                                        aria-label
                                        :checked="selectedRelocation"
                                        v-model="selectedRelocation"
                                      />
                                      <label
                                        class="custom-control-label mr-2"
                                        for="promoted-checkbox"
                                      ></label>
                                    </div>

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.relocationFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>
                                <li class="list-group-item-btn col-md-6">
                                  <div class="d-flex">
                                    <span>Status</span>
                                    <div class="d-flex align-items-center icon-container">
                                      {{ getJobStatusMixin(getManagerJobByID.status).title }}
                                    </div>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="
                                      !editIconState.advertisingStartDateFormShow &&
                                        !isInGlobalEditMode
                                    "
                                    @mouseover="editFields.advertisingStartDate = true"
                                    @mouseleave="editFields.advertisingStartDate = false"
                                    class="d-flex"
                                  >
                                    <span>Adv. start date </span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div
                                        v-if="
                                          getManagerJobByID.status !== 1 &&
                                            getManagerJobByID.status !== 3
                                        "
                                        class="edit-btn"
                                      >
                                        <router-link
                                          v-if="editFields.advertisingStartDate"
                                          to
                                          class="mr-1"
                                        >
                                          <i
                                            @click="showEditForm($event)"
                                            id="advertising-start-date"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{
                                        getManagerJobByID.advertizing_start_date
                                          | formatDate({
                                            format: getManagerUserProfile.format_date,
                                            timezone: getManagerUserProfile.timezone,
                                            hasHourAndMinutes: false,
                                          })
                                      }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Adv. start date </b>
                                    </span>

                                    <input
                                      type="text"
                                      class="form-control mr-1"
                                      id="advertising"
                                      :value="
                                        getManagerJobByID.advertizing_start_date
                                          | formatDate({
                                            format: getManagerUserProfile.format_date,
                                            timezone: getManagerUserProfile.timezone,
                                            hasHourAndMinutes: false,
                                          })
                                      "
                                      disabled
                                    />

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.advertisingStartDateFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="
                                      !editIconState.approvalDateFormShow && !isInGlobalEditMode
                                    "
                                    @mouseover="editFields.approvalDate = true"
                                    @mouseleave="editFields.approvalDate = false"
                                    class="d-flex"
                                  >
                                    <span>Approval date </span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div
                                        v-if="
                                          getManagerJobByID.status !== 1 &&
                                            getManagerJobByID.status !== 3
                                        "
                                        class="edit-btn"
                                      >
                                        <router-link v-if="editFields.approvalDate" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="approval-date"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{
                                        getManagerJobByID.published_date
                                          | formatDate({
                                            format: getManagerUserProfile.format_date,
                                            timezone: getManagerUserProfile.timezone,
                                            hasHourAndMinutes: false,
                                          })
                                      }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Approval date </b>
                                    </span>

                                    <input
                                      type="text"
                                      name=""
                                      class="form-control mr-1"
                                      id=""
                                      :value="
                                        getManagerJobByID.published_date
                                          | formatDate({
                                            format: getManagerUserProfile.format_date,
                                            timezone: getManagerUserProfile.timezone,
                                            hasHourAndMinutes: false,
                                          })
                                      "
                                      disabled
                                    />
                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.approvalDateFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="
                                      !editIconState.advertisingEndDateFormShow &&
                                        !isInGlobalEditMode
                                    "
                                    @mouseover="editFields.advertisingEndDate = true"
                                    @mouseleave="editFields.advertisingEndDate = false"
                                    class="d-flex"
                                  >
                                    <span>Adv. end date</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div class="edit-btn"></div>
                                      {{
                                        getManagerJobByID.advertizing_end_date
                                          | formatDate({
                                            format: getManagerUserProfile.format_date,
                                            timezone: getManagerUserProfile.timezone,
                                            hasHourAndMinutes: false,
                                          })
                                      }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <span>Adv. end date</span>
                                    </span>

                                    <input
                                      type="date"
                                      class="form-control"
                                      id="datepicker-trigger42"
                                      placeholder="Select end date"
                                      disabled
                                    />

                                    <!--        <AirbnbStyleDatepicker
                                    :trigger-element-id="'datepicker-trigger42'"
                                    :mode="'single'"
                                    :fullscreen-mobile="true"
                                    @date-one-selected="
                                      val => {
                                        dateOne = val;
                                      }
                                    "
                                  /> -->

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>

                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.advertisingEndDateFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.createdAtFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.createdAt = true"
                                    @mouseleave="editFields.createdAt = false"
                                    class="d-flex"
                                  >
                                    <span>
                                      <b>Created date</b>
                                    </span>

                                    <div class="custom-control icon-container">
                                      <div class="edit-btn"></div>
                                      {{
                                        getManagerJobByID.created_at
                                          | formatDate({
                                            format: getManagerUserProfile.format_date,
                                            timezone: getManagerUserProfile.timezone,
                                            hasHourAndMinutes: false,
                                          })
                                      }}
                                    </div>
                                  </div>

                                  <span class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Created date</b>
                                    </span>

                                    <input
                                      type="text"
                                      id="created-date"
                                      class="form-control"
                                      :value="
                                        getManagerJobByID.created_at
                                          | formatDate({
                                            format: getManagerUserProfile.format_date,
                                            timezone: getManagerUserProfile.timezone,
                                            hasHourAndMinutes: false,
                                          })
                                      "
                                      disabled
                                    />

                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.createdAtFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </span>
                                </li>
                                <li class="list-group-item col-md-6" style="white-space: nowrap">
                                  <div
                                    v-if="!editIconState.lastUpdatedFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.lastUpdated = true"
                                    @mouseleave="editFields.lastUpdated = false"
                                    class="d-flex"
                                  >
                                    <span>Updated</span>

                                    <div class="custom-control icon-container">
                                      {{
                                        getManagerJobByID.updated_at
                                          | formatDate({
                                            format: getManagerUserProfile.format_date,
                                            timezone: getManagerUserProfile.timezone,
                                            hasHourAndMinutes: false,
                                          })
                                      }}
                                    </div>
                                  </div>

                                  <span class="d-flex" v-else>
                                    <span>Updated</span>

                                    <input
                                      disabled
                                      :value="
                                        getManagerJobByID.updated_at
                                          | formatDate({
                                            format: getManagerUserProfile.format_date,
                                            timezone: getManagerUserProfile.timezone,
                                            hasHourAndMinutes: false,
                                          })
                                      "
                                      type="text"
                                      class="form-control mr-1"
                                    />
                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.lastUpdatedFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </span>
                                </li>
                              </div>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- COMMENTS TAB BODY -->
                    <div
                      class="tab-pane fade"
                      id="nav-comments"
                      role="tabpanel"
                      aria-labelledby="nav-comments-tab"
                    >
                      <ManagerComments
                        :key="key"
                        @add-candidate-comment="addCommentHandler"
                        @remove-comment="deleteCommentHandler"
                        @edit-comment="editCommentHandler"
                        :commentsList="getManagerComments"
                      />
                    </div>
                    <!-- END COMMENTS TAB BODY -->

                    <!-- REQUIREMENTS TAB BODY -->
                    <div
                      class="tab-pane fade"
                      id="nav-requirements"
                      role="tabpanel"
                      aria-labelledby="nav-requirements-tab"
                    >
                      <div class="mobile-clear">
                        <div class="row">
                          <div class="col-md-12">
                            <section>
                              <div class="description-text">
                                <h6 class="d-none d-block d-sm-none req-mobile">Requirements</h6>
                              </div>
                              <ul
                                style="min-height: 550px"
                                class="list-group list-group-flush job-details job-details-description"
                              >
                                <li class="list-group-item border-top-0">
                                  <div
                                    v-if="
                                      !editIconState.yearsOfExperianceFormShow &&
                                        !isInGlobalEditMode
                                    "
                                    @mouseover="editFields.yearsOfExperiance = true"
                                    @mouseleave="editFields.yearsOfExperiance = false"
                                    class="d-flex"
                                  >
                                    <span>Years of experience</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div
                                        v-if="
                                          getManagerJobByID.status !== 1 &&
                                            getManagerJobByID.status !== 3
                                        "
                                        class="edit-btn"
                                      >
                                        <router-link
                                          v-if="editFields.yearsOfExperiance"
                                          to
                                          class="mr-1"
                                        >
                                          <i
                                            @click="showEditForm($event)"
                                            id="years-of-experience"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ getManagerJobByID.years_experience }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span> Years of experience </span>

                                    <div>
                                      <input
                                        type="text"
                                        class="form-control"
                                        v-model="selectedYearsExperience"
                                      />
                                    </div>
                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.yearsOfExperianceFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>

                                <li class="list-group-item">
                                  <div
                                    v-if="!editIconState.degreeFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.degree = true"
                                    @mouseleave="editFields.degree = false"
                                    class="d-flex"
                                  >
                                    <span>Degree</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div
                                        v-if="
                                          getManagerJobByID.status !== 1 &&
                                            getManagerJobByID.status !== 3
                                        "
                                        class="edit-btn"
                                      >
                                        <router-link v-if="editFields.degree" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="degree"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ getDegreeName(getManagerJobByID.degree_type) }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Degree</b>
                                    </span>

                                    <div>
                                      <select
                                        id="degree"
                                        v-model="selectedDegreeType"
                                        class="form-select w-100"
                                        style="box-shadow: none"
                                      >
                                        <option :value="0">Select Degree type</option>
                                        <option :value="1">University</option>
                                        <option :value="2">Bachelor's degree</option>
                                        <option :value="3">Master's degree</option>
                                        <option :value="4">PhD</option>
                                      </select>
                                    </div>
                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.degreeFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>
                                <li class="list-group-item">
                                  <!--   <span class="item-title">Degree field</span>
                                <span class="item-body">{{ getManagerJobByID.degree_field }}</span> -->

                                  <div
                                    v-if="!editIconState.degreeFieldFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.degreeField = true"
                                    @mouseleave="editFields.degreeField = false"
                                    class="d-flex"
                                  >
                                    <span>Degree field</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div
                                        v-if="
                                          getManagerJobByID.status !== 1 &&
                                            getManagerJobByID.status !== 3
                                        "
                                        class="edit-btn"
                                      >
                                        <router-link v-if="editFields.degreeField" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="degree-field"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      {{ getManagerJobByID.degree_field }}
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Degree field</b>
                                    </span>

                                    <div>
                                      <input
                                        id="selected-degree-field"
                                        type="text"
                                        class="form-control w-100"
                                        v-model="selectedDegreeField"
                                      />
                                    </div>
                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.degreeFieldFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>
                                <li class="list-group-item">
                                  <div
                                    v-if="
                                      !editIconState.competencesRequiredFormShow &&
                                        !isInGlobalEditMode
                                    "
                                    @mouseover="editFields.competencesRequired = true"
                                    @mouseleave="editFields.competencesRequired = false"
                                    class="d-flex"
                                  >
                                    <span>Required competencies</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div
                                        v-if="
                                          getManagerJobByID.status !== 1 &&
                                            getManagerJobByID.status !== 3
                                        "
                                        class="edit-btn"
                                      >
                                        <router-link
                                          v-if="editFields.competencesRequired"
                                          to
                                          class="mr-1"
                                        >
                                          <i
                                            @click="showEditForm($event)"
                                            id="competences-required"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <div class="item-body">
                                        <div class="tech-icons">
                                          <div class="d-flex">
                                            <div
                                              class="text-center icon-container"
                                              v-for="competence in getManagerJobByID.required_competences"
                                              :key="competence.id"
                                            >
                                              <IconMapper :competence="competence" />
                                            </div>
                                          </div>

                                          <div class="mt-3 d-block d-sm-none">
                                            <a data-toggle="collapse" href="#collapseExample">
                                              <i class="fas fa-ellipsis-h ml-3"></i
                                            ></a>
                                          </div>

                                          <div
                                            class="collapse show-more-icons shadow"
                                            id="collapseExample"
                                          >
                                            <div class="d-flex tech-icons">
                                              <div
                                                class="text-center icon-container"
                                                v-for="competence in getManagerJobByID.required_competences"
                                                :key="competence.id"
                                              >
                                                <IconMapper :competence="competence" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Required competencies</b>
                                    </span>

                                    <div>
                                      <v-select
                                        v-model="selectedCompetences"
                                        label="name"
                                        :options="getCompetencesFilterList"
                                        :reduce="competence => competence"
                                        :clearable="true"
                                        multiple
                                        id="add-job-competences"
                                      />
                                    </div>
                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.competencesRequiredFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>
                                <li class="list-group-item">
                                  <div
                                    v-if="
                                      !editIconState.competencesAdvantageFormShow &&
                                        !isInGlobalEditMode
                                    "
                                    @mouseover="editFields.competencesAdvantage = true"
                                    @mouseleave="editFields.competencesAdvantage = false"
                                    class="d-flex"
                                  >
                                    <span>Advantage competencies</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div
                                        v-if="
                                          getManagerJobByID.status !== 1 &&
                                            getManagerJobByID.status !== 3
                                        "
                                        class="edit-btn"
                                      >
                                        <router-link
                                          v-if="editFields.competencesAdvantage"
                                          to
                                          class="mr-1"
                                        >
                                          <i
                                            @click="showEditForm($event)"
                                            id="competences-advantage"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <div class="item-body">
                                        <div class="tech-icons">
                                          <div class="d-flex">
                                            <div
                                              class="text-center icon-container"
                                              v-for="competence in getManagerJobByID.advantage_competences"
                                              :key="competence.id"
                                            >
                                              <IconMapper :competence="competence" />
                                            </div>
                                          </div>

                                          <div class="mt-3 d-block d-sm-none">
                                            <a data-toggle="collapse" href="#collapseExample">
                                              <i class="fas fa-ellipsis-h ml-3"></i
                                            ></a>
                                          </div>

                                          <div
                                            class="collapse show-more-icons shadow"
                                            id="collapseExample"
                                          >
                                            <div class="d-flex tech-icons">
                                              <div
                                                class="text-center icon-container"
                                                v-for="competence in getManagerJobByID.required_competences"
                                                :key="competence.id"
                                              >
                                                <IconMapper :competence="competence" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Advantage competencies</b>
                                    </span>

                                    <div class="item-body w-100">
                                      <v-select
                                        v-model="selectedCompetencesAdvantage"
                                        label="name"
                                        :options="getCompetencesFilterList"
                                        :reduce="competence => competence"
                                        :clearable="true"
                                        multiple
                                        id="add-job-competences-advantage"
                                      />
                                    </div>
                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.competencesAdvantageFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>
                                <li class="list-group-item border-bottom d-flex align-items-center">
                                  <div
                                    v-if="!editIconState.languagesFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.languages = true"
                                    @mouseleave="editFields.languages = false"
                                    class="d-flex"
                                  >
                                    <span>Language skills</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div
                                        v-if="
                                          getManagerJobByID.status !== 1 &&
                                            getManagerJobByID.status !== 3
                                        "
                                        class="edit-btn"
                                      >
                                        <router-link v-if="editFields.languages" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="languages"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                      </div>
                                      <div class="item-body">
                                        <div class="tech-icons">
                                          <div class="d-flex">
                                            <div
                                              class="text-center icon-container"
                                              v-for="competence in getManagerJobByID.languages"
                                              :key="competence.id"
                                            >
                                              <IconMapper :competence="competence" />
                                            </div>
                                          </div>

                                          <div class="mt-3 d-block d-sm-none">
                                            <a data-toggle="collapse" href="#collapseExample">
                                              <i class="fas fa-ellipsis-h ml-3"></i
                                            ></a>
                                          </div>

                                          <div
                                            class="collapse show-more-icons shadow"
                                            id="collapseExample"
                                          >
                                            <div class="d-flex tech-icons">
                                              <div
                                                class="text-center icon-container"
                                                v-for="competence in getManagerJobByID.required_competences"
                                                :key="competence.id"
                                              >
                                                <IconMapper :competence="competence" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Language skills</b>
                                    </span>

                                    <div class="item-body w-100">
                                      <v-select
                                        v-model="selectedLanguages"
                                        label="name"
                                        :options="getLanguagesList"
                                        :reduce="language => language"
                                        :clearable="true"
                                        multiple
                                        id="add-job-competences-advantage"
                                      />
                                    </div>
                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.languagesFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>
                                <li class="list-group-item borderless">
                                  <!--   <span class="item-title">Degree field</span>
                                <span class="item-body">{{ getManagerJobByID.degree_field }}</span> -->

                                  <div
                                    v-if="!editIconState.summaryFormShow && !isInGlobalEditMode"
                                    @mouseover="editFields.summary = true"
                                    @mouseleave="editFields.summary = false"
                                    class="d-flex new"
                                  >
                                    <span>Summary</span>

                                    <div class="d-flex align-items-center icon-container">
                                      <div
                                        v-if="
                                          getManagerJobByID.status !== 1 &&
                                            getManagerJobByID.status !== 3
                                        "
                                        class="edit-btn"
                                      >
                                        <router-link v-if="editFields.summary" to class="mr-1">
                                          <i
                                            @click="showEditForm($event)"
                                            id="summary"
                                            class="fas fa-pen edit-icon"
                                          ></i>
                                        </router-link>
                                        <!-- getManagerJobByID.status === 1 || getManagerJobByID.status === 3 -->
                                      </div>
                                      <div style="width: 100%;">
                                        {{
                                          getManagerJobByID.summary
                                            ? getManagerJobByID.summary
                                            : getManagerJobByID.status === 1 ||
                                              getManagerJobByID.status === 3
                                            ? ''
                                            : 'Enter a short description of the position and work. You can also share other things related to your needs here.'
                                        }}
                                      </div>
                                    </div>
                                  </div>

                                  <div class="d-flex" v-else>
                                    <span class="mr-0">
                                      <b>Summary</b>
                                    </span>

                                    <div>
                                      <input
                                        id="selected-degree-field"
                                        type="text"
                                        class="form-control w-100"
                                        placeholder="Enter a short description of the position and work. You can also share other things related to your needs here."
                                        v-model="selectedSummary"
                                        autocomplete="off"
                                      />
                                    </div>
                                    <button
                                      v-show="!isInGlobalEditMode"
                                      type="submit"
                                      class="btn btn-outline btn-sm border mr-1"
                                    >
                                      <i class="fas fa-check"></i>
                                    </button>
                                    <CandidateEditFieldCancelBtn
                                      v-show="!isInGlobalEditMode"
                                      @clicked="editIconState.summaryFormShow = false"
                                    >
                                      <i class="fas fa-times"></i>
                                    </CandidateEditFieldCancelBtn>
                                  </div>
                                </li>
                              </ul>
                            </section>

                            <!-- GLOBAL EDIT MODE -->
                            <!--  <section v-else>
                            <div class="description-text">
                              <h6 class="d-none d-block d-sm-none req-mobile">Requirements</h6>
                            </div>
                            <ul class="list-group list-group-flush job-details">
                                <li class="list-group-item border-top-0 d-flex align-items-center">
                                <span class="item-title">Years of experience</span>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="selectedYearsExperience"
                                />
                              </li>
                               <li class="list-group-item d-flex align-items-center">
                                <span class="item-title">Degree</span>
                                <span class="item-body">
                                  <select
                                    id="degree-type"
                                    v-model="selectedDegreeType"
                                    class="form-select w-100"
                                    style="box-shadow: none"
                                  >
                                    <option :value="0">Select Degree type</option>
                                    <option :value="1">University</option>
                                    <option :value="2">Bachelor's degree</option>
                                    <option :value="3">Master's degree</option>
                                    <option :value="4">PhD</option>
                                  </select>
                                </span>
                              </li>
                              <li class="list-group-item d-flex align-items-center">
                                <span class="item-title">Degree field</span>

                                <input
                                  id="selected-degree-field"
                                  type="text"
                                  class="form-control w-100"
                                  v-model="selectedDegreeField"
                                />
                              </li>

                              <li class="list-group-item d-flex align-items-center">
                                <span class="item-title">Competences required</span>
                                <div class="item-body w-100">
                                  <v-select
                                    v-model="selectedCompetences"
                                    label="name"
                                    :options="getCompetencesFilterList"
                                    :reduce="(competence) => competence"
                                    :clearable="true"
                                    multiple
                                    id="add-job-competences"
                                  />
                                </div>
                              </li>

                               <li class="list-group-item d-flex align-items-center">
                                <span class="item-title">Competences advantage</span>
                                <div class="item-body w-100">
                                  <v-select
                                    v-model="selectedCompetencesAdvantage"
                                    label="name"
                                    :options="getCompetencesFilterList"
                                    :reduce="(competence) => competence"
                                    :clearable="true"
                                    multiple
                                    id="add-job-competences-advantage"
                                  />
                                </div>
                              </li>
                              <li class="list-group-item border-bottom d-flex align-items-center">
                                <span class="item-title">Languages</span>
                                <div class="item-body w-100">
                                  <v-select
                                    v-model="selectedLanguages"
                                    label="name"
                                    :options="getLanguagesList"
                                    :reduce="(language) => language"
                                    :clearable="true"
                                    multiple
                                    id="add-job-competences-advantage"
                                  />
                                </div>
                              </li>
                            </ul>
                          </section> -->
                            <!-- END GLOBAL EDIT MODE -->
                          </div>
                        </div>
                        <!-- <JobItemRequirements /> -->
                      </div>
                    </div>
                    <!-- END REQUIREMENTS TAB BODY -->

                    <!-- Ad Mobile Only TAB BODY -->
                    <div
                      class="tab-pane fade"
                      id="nav-ad"
                      role="tabpanel"
                      aria-labelledby="nav-ad-tab"
                    >
                      <div class="mobile-clear">
                        <div style="margin-top: 30px;">
                          <div class="col-md-12">
                            <section>
                              <div class="description-text">
                                <h6 class="d-none d-block d-sm-none req-mobile">Description</h6>
                              </div>
                              <div class="description-text">
                                <div class="d-flex">
                                  <h6 class="mt-4">Description</h6>
                                  <div class="ml-auto buttons mb-2">
                                    <div v-if="!editText" class="edit-btn">
                                      <router-link
                                        to
                                        v-if="
                                          getManagerJobByID.status !== 1 &&
                                            getManagerJobByID.status !== 3
                                        "
                                      >
                                        <i
                                          @click="onEditText(getManagerJobByID.description)"
                                          id="lastUpdated"
                                          class="fas fa-pen edit-icon"
                                          style="color: #666"
                                        ></i>
                                      </router-link>
                                    </div>
                                    <div v-else>
                                      <button
                                        type="submit"
                                        class="btn btn-outline btn-sm border mr-1"
                                      >
                                        <i style="color: green" class="fas fa-check"></i>
                                      </button>
                                      <CandidateEditFieldCancelBtn @clicked="editText = false">
                                        <i class="fas fa-times" style="color: red"></i>
                                      </CandidateEditFieldCancelBtn>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  v-show="!editText"
                                  class="description-text-body description-scroll pb-4"
                                  v-html="getManagerJobByID.description"
                                ></div>
                                <div v-show="editText" class="text-editor manager-editor">
                                  <TextEditor v-model="selectedDescription" />
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                        <!-- <JobItemRequirements /> -->
                      </div>
                    </div>
                    <!-- END REQUIREMENTS TAB BODY -->

                    <div
                      class="tab-pane fade"
                      id="nav-activity"
                      role="tabpanel"
                      aria-labelledby="nav-comments-tab"
                    >
                      <!-- <Activities /> -->
                    </div>
                    <div
                      class="tab-pane fade"
                      id="nav-pipelines"
                      role="tabpanel"
                      aria-labelledby="nav-emails-tab"
                    >
                      <h6 class="d-none d-block d-sm-none req-mobile mb-1 aside-title">
                        Pipelines
                      </h6>
                      <!-- <JobItemPipeline></JobItemPipeline> -->
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="col-md-4 desktop-only job-aside-activity">
            <ManagerActivities
              haveAddActivity
              :activities="currentActivities"
              @getActivities="loadMoreActivities"
            />
          </div>
        </div>
        <div class="desktop-pipelines">
          <ManagerJobItemPipeline @newActivity="getActivities" />
        </div>
      </section>

      <!-- Delete Job Modal -->
      <div
        class="modal fade edit-modal"
        id="deleteJobModal"
        tabindex="-1"
        aria-labelledby="deleteJobModal"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="deleteJobModal">Delete Job</h5>
              <button
                ref="closeModalBtn"
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body text-center justify-content-center">
              <p>
                Please confirm that you want to delete <strong>{{ getManagerJobByID.title }}</strong
                >. This action will permanently delete the information.
              </p>
            </div>
            <div class="modal-footer text-center justify-content-center">
              <button @click="removeJob" type="button" class="btn btn-primary">Delete</button>

              <button
                ref="closeModalBtn"
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- End Delete Job Modal -->

      <!-- Pipeline -->
    </div>
    <!-- End page-content-wrapper -->

    <CustomMainModal
      @close="jobStatusModalShow = false"
      v-show="jobStatusModalShow"
      :header="false"
      modalSize="modal-md"
    >
      <p v-if="getManagerJobByID.status === 1 || getManagerJobByID.status === 3">
        Please confirm that you want to stop publishing this job. This means the job will no longer
        be active, and Jobshark will cease all activities related to finding suitable candidates.
      </p>
      <p v-else>
        Please confirm that you want to publish this job. The job will be published after our
        review.
      </p>
      <div class="modal-footer justify-content-center pb-0">
        <button
          type="button"
          class="btn btn-primary"
          @click="updateStatus(getManagerJobByID.status)"
        >
          {{
            getManagerJobByID.status === 1 || getManagerJobByID.status === 3
              ? 'Stop Publishing'
              : 'Publish'
          }}
        </button>
        <button type="button" class="btn btn-secondary" @click="onCancelSetJobStatus">
          Cancel
        </button>
      </div>
    </CustomMainModal>
    <Spinner :isLoading="isLoading" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { toggleSidebarNav } from '../../../mixins/toggleSidebarNav';

import ManagerJobItemPipeline from './ManagerJobItemPipeline';
import TopNavbar from '../../Navigations/TopNavbar';
import ManagerActivities from '../common/ManagerActivities';
import ManagerComments from '../common/ManagerComments';
import ManagerSidebar from '@/components/Navigations/ManagerSidebar';
import axios from 'axios';
/* import AddJobBtnModal from './AddJobBtnModal'; */
import CustomMainModal from '../../Modals/CustomMainModal';
import CandidateEditFieldCancelBtn from '../common/CandidateEditFieldCancelBtn.vue';

// Activities AND EMAILS
/* import Emails from '../common/Emails'; */

/* import JobItemRequirements from '../Jobs/JobItemRequirements'; */

// Icons
import IconMapper from '../../common/iconMapper';

// PIPELINE
import { degreeMixin } from '../../../mixins/degreeMixin';
import { stagesMixin } from '../../../mixins/stagesMixin';
import { employmentMixin } from '../../../mixins/employmentMixin';
import { jobStatusMixin } from '../../../mixins/jobStatusMixin';
import { serviceLevelMixin } from '../../../mixins/serviceLevelMixin';
import { errorService } from '../../../services/errorService';
import TextEditor from '@/components/common/TextEditor';
import { MESSAGES } from '../../../constants';
import moment from 'moment';
import titleMixin from '../../../mixins/titleMixin';

export default {
  components: {
    CandidateEditFieldCancelBtn,
    TextEditor,
    IconMapper,
    TopNavbar,
    CustomMainModal,
    ManagerSidebar,
    ManagerActivities,
    ManagerComments,
    ManagerJobItemPipeline,
  },
  mixins: [
    toggleSidebarNav,
    degreeMixin,
    stagesMixin,
    employmentMixin,
    jobStatusMixin,
    serviceLevelMixin,
    titleMixin,
  ],
  title() {
    return this.getManagerJobByID ? `${this.getManagerJobByID.title} | Jobshark` : 'Job | Jobshark';
  },
  watch: {
    '$route.params.manager_job_uuid': {
      handler(newParams, oldParams) {
        if (newParams !== oldParams) {
          this.loadJob();
        }
      },
      deep: true, // This is used to watch for changes within the object
    },
  },
  data: () => ({
    currentActivities: [],
    currentPage: 1,
    pageCount: 20,
    last_page: '',
    editText: false,
    currentStatus: 'Active',
    editFields: {
      workplace: false,
      summary: false,
      employer: false,
      city: false,
      country: false,
      street: false,
      employment: false,
      advertisingStartDate: false,
      approvalDate: false,
      advertisingEndDate: false,
      promoted: false,
      createdBy: false,
      createdAt: false,
      lastUpdated: false,
      yearsOfExperiance: false,
      degree: false,
      degreeField: false,
      competencesRequired: false,
      competencesAdvantage: false,
      languages: false,
      postal: false,
      relocation: false,
      individuals: false,
      fullTime: false,
      duration: false,
    },
    editIconState: {
      workplaceFormShow: false,
      summaryFormShow: false,
      individualsFormShow: false,
      fullTimeFormShow: false,
      durationFormShow: false,
      employerFormShow: false,
      cityFormShow: false,
      countryFormShow: false,
      postalCodeFormShow: false,
      streetFormShow: false,
      employmentFormShow: false,
      advertisingStartDateFormShow: false,
      approvalDateFormShow: false,
      advertisingEndDateFormShow: false,
      promotedFormShow: false,
      createdByFormShow: false,
      createdAtFormShow: false,
      lastUpdatedFormShow: false,
      yearsOfExperianceFormShow: false,
      degreeFormShow: false,
      degreeFieldFormShow: false,
      competencesRequiredFormShow: false,
      competencesAdvantageFormShow: false,
      languagesFormShow: false,
      relocationFormShow: false,
    },
    jobStatusModalShow: false,
    jobStatusOptions: [
      { value: 0, label: 'Active' },
      { value: 1, label: 'Submitted' },
      { value: 2, label: 'Approved' },
      { value: 3, label: 'Published' },
      { value: 4, label: 'Rejected' },
      { value: 5, label: 'Closed' },
    ],
    key: 0,

    showModal: false,
    isToggled: false,
    isLoading: false,
    isInGlobalEditMode: false,
    actualJobStatus: 0,
    competencesAdv: [],
    competences: [],
    selectedCity: {},
    selectedJobStatus: 0,
    selectedCountry: '',
    selectedServiceLevel: { id: 0, service: 'Basic' },
    selectedJobTitle: '',
    selectedYearsExperience: '',
    selectedSummary: '',
    selectedIndividuals: 0,
    selectedFullTime: true,
    selectedDuration: '',
    selectedWorkplace: '',
    selectedDegreeType: 0,
    selectedDegreeField: '',
    selectedCompetences: [],
    selectedCompetencesAdvantage: [],
    selectedEmploymentType: 1,
    selectedLanguages: [],
    selectedRelocation: false,
    selectedPostalCode: '',
    selectedPromoted: false,
    selectedAddress: '',
    selectedEndDate: '',
    dateOne: '',
    jobAdData: {},
    selectedDescription: '',
    jobAdText: '',
  }),
  methods: {
    ...mapActions('managerStoreModule', [
      'retrieveManagerUserProfile',
      'retrieveManagerJobById',
      'retrieveManagerProfile',
      'retrieveManagerCommentsList',
      'updateManagerJobAdById',
      'addManagerComment',
      'removeManagerComment',
      'editManagerComment',
      'retrieveManagerJobActivities',
      'sendManagerRecent',
    ]),
    ...mapActions([
      'retrieveLanguagesList',
      'retrieveAllCountries',
      'retrieveCitiesListByCountryId',
      'retrieveCompetencesList',
      'retrieveEmployersDropdown',
    ]),
    removeHtmlTags(adText, ...args) {
      const removeAllDivTags = /<[/]{0,1}(div)[^><]*>/g;
      const removeInlineStyles = /style=["']?([a-zA-Z0-9 :\-#()._;',\s\n\r&]+);?["']?|<\s*font[^>]*>/g;

      return adText
        .replace(removeAllDivTags, '')
        .replace(removeInlineStyles, '')
        .replace(/<!--.*?-->/g, '')
        .replace(/\r?\n/g, '');
    },
    onEditText(desc) {
      this.selectedDescription = this.removeHtmlTags(desc, 'p');
      this.editText = true;
    },
    getActivities() {
      this.currentPage = 1;
      this.retrieveManagerJobActivities({
        uuid: this.$route.params.manager_job_uuid,
        count: this.pageCount,
        page: this.currentPage,
      }).then(() => {
        this.currentActivities = this.getManagerJobActivities.data;
        this.last_page = this.getManagerJobActivities.last_page;
      });
    },
    loadMoreActivities() {
      if (this.currentPage < this.last_page) {
        this.currentPage++;
        this.retrieveManagerJobActivities({
          uuid: this.$route.params.manager_job_uuid,
          count: this.pageCount,
          page: this.currentPage,
        }).then(() => {
          this.currentActivities = [
            ...this.currentActivities,
            ...Object.values(this.getManagerJobActivities.data),
          ];
        });
      }
    },
    loadJob() {
      this.isLoading = true;
      this.sendManagerRecent({ jobad_id: this.$route.params.manager_job_uuid });
      this.retrieveManagerJobActivities({
        uuid: this.$route.params.manager_job_uuid,
        count: this.pageCount,
        page: this.currentPage,
      }).then(() => {
        this.currentActivities = this.getManagerJobActivities.data;
        this.last_page = this.getManagerJobActivities.last_page;
      });
      this.retrieveManagerUserProfile().then(() => {
        this.retrieveManagerJobById({ jobID: this.$route.params.manager_job_uuid })
          .then(() => {
            this.retrieveLanguagesList();
            this.retrieveAllCountries();
            this.updateMeta();
            this.retrieveManagerCommentsList({ uuid: this.$route.params.manager_job_uuid });
            /* Default values */

            this.selectedEmploymentType = this.getManagerJobByID.employment_type;
            this.selectedJobTitle = this.getManagerJobByID.title;
            this.selectedCountry = this.getManagerJobByID.country;
            this.selectedCity = this.getManagerJobByID.city;
            this.selectedYearsExperience = this.getManagerJobByID.years_experience;
            this.selectedDegreeType = this.getManagerJobByID.degree_type;
            this.selectedRelocation = this.getManagerJobByID.relocation;
            this.selectedDegreeField = this.getManagerJobByID.degree_field;
            this.selectedAddress = this.getManagerJobByID.street;
            this.selectedJobStatus = this.getManagerJobByID.status;
            this.selectedPostalCode = this.getManagerJobByID.address.postal_code;
            this.selectedIndividuals = this.getManagerJobByID.individuals_number;
            this.selectedFullTime = this.getManagerJobByID.full_time;
            this.selectedDuration = this.getManagerJobByID.duration;
            this.selectedServiceLevel = this.getManagerJobByID.service_level;
            this.selectedSummary = this.getManagerJobByID.summary;
            this.selectedWorkplace = this.getManagerJobByID.workplace;
            this.selectedCompetences = this.getManagerJobByID.required_competences.map(c => {
              return { ...c, id: c.competence_id };
            });
            this.selectedCompetencesAdvantage = this.getManagerJobByID.advantage_competences.map(
              c => {
                return { ...c, id: c.competence_id };
              },
            );
            this.selectedLanguages = this.getManagerJobByID.languages.map(l => {
              return { ...l, id: l.language_id };
            });

            this.selectedDescription = this.removeHtmlTags(this.getManagerJobByID.description);

            /* End Default values */
            this.retrieveCitiesListByCountryId({ id: this.selectedCountry.id });
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });

        /*     this.retrieveActivitiesForJob({ jobad_id: this.$route.params.job_uuid, page: 1, count: 10 });
    this.retrieveJobComments({ uuid: this.$route.params.job_uuid });

    // TODO: move these to the main component
    this.retrieveUserProfile();
    */
        this.retrieveCompetencesList();
        this.retrieveManagerProfile().then(() => {});
      });
    },
    updateStatus(status) {
      let current = status;
      if (status === 1 || status === 3) {
        current = 0;
      } else {
        current = 1;
      }
      axios(`${process.env.VUE_APP_API_URL}/manager/jobs/updatestatus`, {
        method: 'post',
        data: {
          js_employer_jobad_id: this.$route.params.manager_job_uuid,
          status: current,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.retrieveManagerJobById({ jobID: this.$route.params.manager_job_uuid });
          this.jobStatusModalShow = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    onCancelUpdateForm() {
      this.isInGlobalEditMode = false;
      this.$refs.updateForm.reset();
    },
    clearCity() {
      this.selectedCity = '';
    },
    showEditForm(e) {
      if (e.target.id === 'workplace') {
        this.editIconState.workplaceFormShow = !this.editIconState.workplaceFormShow;
      }
      if (e.target.id === 'summary') {
        this.editIconState.summaryFormShow = !this.editIconState.summaryFormShow;
      }
      if (e.target.id === 'need-individuals') {
        this.editIconState.individualsFormShow = !this.editIconState.individualsFormShow;
      }
      if (e.target.id === 'duration') {
        this.editIconState.durationFormShow = !this.editIconState.durationFormShowFormShow;
      }
      if (e.target.id === 'fullTime') {
        this.editIconState.fullTimeFormShow = !this.editIconState.fullTimeFormShow;
      }
      if (e.target.id === 'employer') {
        this.editIconState.employerFormShow = !this.editIconState.employerFormShow;
      }
      if (e.target.id === 'city') {
        this.editIconState.cityFormShow = !this.editIconState.cityFormShow;
      }
      if (e.target.id === 'country') {
        this.editIconState.countryFormShow = !this.editIconState.countryFormShow;
      }
      if (e.target.id === 'street') {
        //  this.selectedAddress = this.getCandidateById.street;

        this.editIconState.streetFormShow = !this.editIconState.streetFormShow;
      }

      if (e.target.id === 'employment') {
        this.editIconState.employmentFormShow = !this.editIconState.employmentFormShow;
      }

      if (e.target.id === 'advertising-start-date') {
        this.editIconState.advertisingStartDateFormShow = !this.editIconState
          .advertisingStartDateFormShow;
      }
      if (e.target.id === 'approval-date') {
        this.editIconState.approvalDateFormShow = !this.editIconState.approvalDateFormShow;
      }
      if (e.target.id === 'advertising-end-date') {
        this.editIconState.advertisingEndDateFormShow = !this.editIconState
          .advertisingEndDateFormShow;
      }
      if (e.target.id === 'competences-required') {
        /*  this.selectedCompetences = this.getCandidateById.competences.map((c) => {
          return { ...c, id: c.competence_id };
        }); */

        this.editIconState.competencesRequiredFormShow = !this.editIconState
          .competencesRequiredFormShow;
      }
      if (e.target.id === 'competences-advantage') {
        /*  this.selectedCompetences = this.getCandidateById.competences.map((c) => {
          return { ...c, id: c.competence_id };
        }); */

        this.editIconState.competencesAdvantageFormShow = !this.editIconState
          .competencesAdvantageFormShow;
      }
      if (e.target.id === 'promoted') {
        this.editIconState.promotedFormShow = !this.editIconState.promotedFormShow;
      }
      if (e.target.id === 'created-by') {
        this.editIconState.createdByFormShow = !this.editIconState.createdByFormShow;
      }
      if (e.target.id === 'created-date') {
        this.editIconState.createdAtFormShow = !this.editIconState.createdAtFormShow;
      }
      if (e.target.id === 'lastUpdated') {
        this.editIconState.lastUpdatedFormShow = !this.editIconState.lastUpdatedFormShow;
      }
      if (e.target.id === 'years-of-experience') {
        this.editIconState.yearsOfExperianceFormShow = !this.editIconState
          .yearsOfExperianceFormShow;
      }
      if (e.target.id === 'degree') {
        this.editIconState.degreeFormShow = !this.editIconState.degreeFormShow;
      }
      if (e.target.id === 'degree-field') {
        this.editIconState.degreeFieldFormShow = !this.editIconState.degreeFieldFormShow;
      }

      if (e.target.id === 'languages') {
        this.editIconState.languagesFormShow = !this.editIconState.languagesFormShow;
      }

      if (e.target.id === 'postal') {
        this.editIconState.postalCodeFormShow = !this.editIconState.postalCodeFormShow;
      }
      if (e.target.id === 'relocation') {
        this.editIconState.relocationFormShow = !this.editIconState.relocationFormShow;
      }
    },
    showWorkPlace(data) {
      if (data === 1) {
        return 'Onsite';
      } else if (data === 2) {
        return 'Hybrid';
      } else {
        return 'Remote';
      }
    },
    addCommentHandler(comment) {
      if (comment.message) {
        const normalizedComment = comment.message.trim();

        this.addManagerComment({
          uuid: this.$route.params.manager_job_uuid,
          message: normalizedComment,
          js_share: comment.share,
        })
          .then(() => {
            this.retrieveManagerCommentsList({ uuid: this.$route.params.manager_job_uuid });

            this.$toasted.success(MESSAGES.commentAddedSuccess, {
              theme: 'bubble',
              icon: 'fa-unlock-alt',
              position: 'bottom-right',
              duration: 5000,
            });
          })
          .catch(err => {
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-unlock-alt',
              position: 'bottom-right',
              duration: 5000,
            });
          });
      } else {
        this.$toasted.info(MESSAGES.emptyComment, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 10000,
        });
      }
    },
    editCommentHandler(commentData) {
      this.editManagerComment({ uuid: commentData.id, data: commentData.comment })
        .then(() => {
          this.retrieveManagerCommentsList({ uuid: this.$route.params.manager_job_uuid });
          this.$toasted.success(MESSAGES.commentUpdatedSuccess, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(() => {
          this.$toasted.error(MESSAGES.commentUpdatedError, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 10000,
          });
        });
    },
    deleteCommentHandler(commentID) {
      this.removeManagerComment({ uuid: commentID })
        .then(() => {
          this.retrieveManagerCommentsList({ uuid: this.$route.params.manager_job_uuid });

          this.$toasted.show(MESSAGES.commentDeletedSuccess, {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(err => {
          this.$toasted.error(err.response.data.message, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 10000,
          });
        });
    },
    formatDates(date) {
      if (date) {
        return moment().format('YY-DD-MM');
      }
    },
    getCurrentDate() {
      return moment().format('DD-MMM-YYYY');
    },
    reloadActivity() {
      this.retrieveActivitiesForJob({
        jobad_id: this.$route.params.job_uuid,
        page: 1,
        count: 1000,
      });
    },

    setJobForRemoval() {},
    setCityModel(e) {
      this.selectedCity = e;
    },
    fetchCitiesByCountryId(e) {
      this.selectedCountry = e;

      this.retrieveCitiesListByCountryId({ id: this.selectedCountry.id });
    },
    removeJob() {
      axios
        .delete(
          `${process.env.VUE_APP_API_URL}/manager/jobs/delete/${this.$route.params.manager_job_uuid}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(() => {
          this.$refs.closeModalBtn.click();
          this.$router.push({ name: 'manager-jobs' });
        })
        .catch(err => {
          this.$toasted.error('Unable to delete job ad. Please contact administrator.', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    onChangeJobStatus() {
      this.jobStatusModalShow = true;
    },
    saveNewJobStatus() {
      this.isLoading = true;

      this.setJobStatus({
        js_employer_jobad_id: this.$route.params.job_uuid,
        status: this.selectedJobStatus,
      })
        .then(() => {
          this.isLoading = false;
          this.jobStatusModalShow = false;

          this.$toasted.success(
            `Job Status changed from ${this.getJobStatusMixin(this.actualJobStatus).title} to ${
              this.getJobStatusMixin(this.selectedJobStatus).title
            }`,
            {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 10000,
            },
          );

          this.actualJobStatus = this.selectedJobStatus;
        })
        .catch(err => {
          this.$toasted.error(`${err}`, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    onCancelSetJobStatus() {
      this.jobStatusModalShow = false;
    },
    forceRerender() {
      this.key += 1;
    },
    changeGlobalEditMode() {
      this.isInGlobalEditMode = !this.isInGlobalEditMode;
    },
    calculateDuration(duration) {
      if (Number(duration) === 1) {
        return 'Permanent employment';
      } else if (Number(duration) === 2) {
        return 'Time-limited employment';
      } else if (Number(duration) === 3) {
        return 'Less than 1 month';
      } else if (Number(duration) === 4) {
        return '1-3 months';
      } else if (Number(duration) === 5) {
        return '3-6 months';
      } else if (Number(duration) === 6) {
        return '6-12 months';
      } else if (Number(duration) === 7) {
        return 'More than 12 months';
      }
    },
    updateJobAd() {
      if (!this.selectedCity || !this.selectedCountry) {
        this.$toasted.error(`Please enter City and Country before editing other information`, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
      } else {
        this.updateManagerJobAdById({
          js_employer_jobad_id: this.$route.params.manager_job_uuid,
          title: this.selectedJobTitle,
          employer_id: this.getManagerJobByID.js_employer_id,
          description: this.selectedDescription,
          city_id: this.selectedCity.id,
          country_id: this.selectedCountry.id,
          employment_type: this.selectedEmploymentType,
          years_experience: this.selectedYearsExperience,
          degree_type: this.selectedDegreeType,
          degree_field: this.selectedDegreeField,
          competences: this.selectedCompetences.map(c => c.id),
          advantage_competences: this.selectedCompetencesAdvantage.map(c => c.id),
          languages: this.selectedLanguages.map(l => l.id),
          relocation: this.selectedRelocation,
          service_level: this.selectedServiceLevel,
          street: this.selectedAddress,
          advertising_end_date: this.selectedEndDate,
          /* end_date: this.endDate, */
          comments: this.comments,
          saved_status: 1,
          promoted: this.selectedPromoted,
          postal_code: this.selectedPostalCode,
          individuals_number: Number(this.selectedIndividuals),
          full_time: this.selectedFullTime,
          duration: Number(this.selectedDuration),
          summary: this.selectedSummary,
          workplace: this.selectedWorkplace,
        })
          .then(() => {
            this.editText = false;
            this.retrieveManagerJobById({ jobID: this.$route.params.manager_job_uuid }).then(() => {
              this.selectedEmploymentType = this.getManagerJobByID.employment_type;
              this.selectedJobTitle = this.getManagerJobByID.title;
              this.selectedCountry = this.getManagerJobByID.country;
              this.selectedCity = this.getManagerJobByID.city;
              this.selectedYearsExperience = this.getManagerJobByID.years_experience;
              this.selectedDegreeType = this.getManagerJobByID.degree_type;
              this.selectedPostalCode = this.getManagerJobByID.address.postal_code;
              this.selectedDegreeField = this.getManagerJobByID.degree_field;
              this.selectedAddress = this.getManagerJobByID.street;
              this.selectedJobStatus = this.getManagerJobByID.status;
              this.selectedIndividuals = this.getManagerJobByID.individuals_number;
              this.selectedFullTime = this.getManagerJobByID.full_time;
              this.selectedDuration = this.getManagerJobByID.duration;
              this.selectedSummary = this.getManagerJobByID.summary;
              this.selectedWorkplace = this.getManagerJobByID.workplace;
              this.selectedCompetences = this.getManagerJobByID.required_competences.map(c => {
                return { ...c, id: c.competence_id };
              });
              this.selectedCompetencesAdvantage = this.getManagerJobByID.advantage_competences.map(
                c => {
                  return { ...c, id: c.competence_id };
                },
              );
              this.selectedLanguages = this.getManagerJobByID.languages.map(l => {
                return { ...l, id: l.language_id };
              });
            });

            this.$toasted.success(MESSAGES.updateJobAdSuccess, {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 10000,
            });

            for (const field in this.editIconState) {
              this.editIconState[field] = false;
            }
          })
          .catch(err => {
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 5000,
            });
          });

        this.isInGlobalEditMode = false;
      }
    },
  },
  computed: {
    ...mapGetters('managerStoreModule', [
      'getAllCountries',
      'getManagerJobByID',
      'getManagerUserProfile',
      'getManagerComments',
      'getManagerProfile',
      'getManagerJobActivities',
    ]),
    ...mapGetters([
      'getLanguagesList',
      'getAllCountries',
      'getCitiesListByCountry',
      'getCompetencesFilterList',
    ]),
  },
  mounted() {
    this.loadJob();

    //this.selectedDescription = this.removeHtmlTags(this.getManagerJobByID.description, 'div');
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.borderless {
  .d-flex {
    height: auto !important;
    span {
      align-self: flex-start;
    }
  }
}

.Ad-tab {
  display: none;
}

.mobile-description-text {
  display: none !important;
}

.hide-on-mobile {
  display: block !important;
}

.ql-snow {
  min-height: 580px;
}
.job-type {
  font-family: $font-family-sans-lato;
}
.candidate-picture {
  width: 64px;
  height: 64px;
  margin-right: 12px;
  img {
    width: 64px;
    height: 64px;
    object-fit: contain;
  }
}
.job-details {
  .edit-fields {
    width: 100%;
    padding-left: 15px;
  }
  span.edit-label {
    font-weight: 700;
    padding-top: 10px;
    width: 150px;
    flex-shrink: 0;
    &.last {
      width: 75px;
    }
  }
}

.job-details-description {
  li {
    span {
      width: 170px;
    }
    div {
      flex: 1;
    }
    b {
      font-weight: 600 !important;
    }
  }
}

.job-edit {
  &-icon {
    fill: #a3a6b4;
    margin-top: -5px;
  }

  &-icon:hover {
    fill: #c1c4d4;
  }
}

.custom-card {
  height: 755px !important;
  overflow: hidden;
}

.job-content {
  max-height: 755px;
  overflow-y: auto;
}

#description {
  padding: 0 24px;
}
.card {
  margin: 0;
}

.job-details {
  font-family: $font-family-sans-lato;
  font-size: 0.875rem;
  li {
    position: relative;
  }

  .icon-container {
    position: relative;
    padding-left: 20px;
  }

  li span {
    display: inline-block;
    font-weight: 700;
    &.icon-container {
      position: relative;
    }
  }
  .empl-icon {
    position: absolute;
    display: inline-block;
    top: 50%;
    transform: translate(0, -50%);
    left: -45px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border: 1px solid #ddd;
      border-radius: 50%;
    }
  }

  font-family: $font-family-sans-lato;
  font-size: 0.875rem;
  overflow: hidden;

  .row {
    margin: 0;
  }

  li.list-group-item {
    padding-left: 0 !important;
    border: none !important;
    padding-right: 0;
    b {
      font-weight: 700 !important;
    }
  }

  li > .d-flex {
    border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
    margin: 3px 12px;
    padding: 12px 0;
    height: 46px;
    flex: 1;
    align-items: center;
  }

  li span {
    min-width: 141px !important;

    white-space: nowrap;
  }

  li > span:not(:nth-child(2n + 0)) {
    font-weight: 700;
    min-width: 19rem;
  }

  .popup {
    background: #fff;
    border: 1px solid #ddd;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
    position: absolute;
    padding: 8px 12px 6px 12px !important;
    top: 75%;
    left: -15px;
    width: 100%;
    height: auto !important;
    z-index: 9;
    flex-wrap: wrap;
  }

  .tech-icons {
    width: 100%;
    position: relative;
    margin-top: -20px;
    .icon-container {
      max-width: 100px;
      text-align: center;
      display: inline-block;
      padding-left: 0;
      &:first-of-type {
        padding-left: 0 !important;
        margin-left: -30px;
        pointer-events: none;
      }
      .icon-wrapper {
        img {
          width: 25px;
          height: 25px;
          display: block;
          margin: 0 auto;
        }
      }
    }
    .btn-secondary {
      background: none !important;
      border: none !important;
      box-shadow: none !important;
      position: absolute;
      top: 13px;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .dropdown-menu {
      width: 100%;
      border-radius: 0;
      .list-inline {
        li {
          margin: 0;
          text-align: center;
          width: 25%;
        }
      }
    }
    .dropdown-toggle {
      &:after {
        display: none;
      }
    }
  }

  .edit-btn {
    position: absolute;
    left: 0;
    .edit-icon {
      color: #666;
    }
  }
}

/deep/ .description-text {
  h6 {
    font-size: 1.125rem;
    font-weight: 700;
  }

  &-body {
    font-size: 0.875rem;
    font-family: $font-family-sans-lato;
  }
}

/* Title Header */
.job-edit {
  &-icon {
    fill: #a3a6b4;
  }

  &-icon:hover {
    fill: #c1c4d4;
  }
}

.header-title {
  width: 100%;
  padding: 25px 0 5px 6px;

  &-name {
    font: 21px Montserrat;
    letter-spacing: 0;
    color: #000;
    flex: 1;
  }
  .single-job-controls {
    margin-left: 6px;
  }

  .name-edit {
    flex-shrink: 0;
  }
}

.list-group-item {
  border: none;
  border-bottom: 1px solid #ddd;
  padding-left: 0;

  .btn {
    background-color: #fff;
    border: 1px solid rgba(60, 60, 60, 0.26) !important;
    width: 24px;
    height: 24px;
    margin-left: 5px;
    font-size: 12px;
    flex-shrink: 0;
    border-radius: 5px;
    padding: 0;
    align-items: center;
    justify-content: center;
    text-align: center;
    .fa-check {
      color: green;
    }
    .fa-times {
      color: Red;
    }
  }
}
.list-group-item-btn {
  display: flex;
  border: none;
  padding-left: 0;
  .d-flex {
    flex: 1;
    .btn {
      font-size: 0.875rem;
      padding: 4px 6px;
      margin-left: auto;
    }
  }
}

.mobile-only {
  display: none !important;
}

.desktop-only {
  display: block;
}

@media only screen and (max-width: 1251px) {
  .card {
    margin-top: 26px !important;
  }
  .job-aside-activity {
    display: none !important;
  }
}

@media only screen and (max-width: 992px) {
  .mobile-clear {
    padding: 0 17px;
  }
  #description {
    .container {
      max-width: 100%;
    }
    .col-md-8 {
      display: block;
      flex: 100%;
      width: 100% !important;
      max-width: 100%;
    }
    padding: 0;
    .card {
      margin: 26px 0 0 0 !important;
      min-height: auto;
      height: auto !important;
      .tab-content {
        margin: 0 !important;
      }
    }
    .description-scroll {
      max-height: 100%;
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
}

@media only screen and (max-width: 768px) {
  .Ad-tab {
    display: block;
  }
  #description {
    .job-details {
      .list-group-item {
        padding-left: 0 !important;
      }
    }
    padding: 0;
    .card {
      margin: 26px 0 0 0 !important;
      min-height: auto;
      height: auto !important;
      padding-bottom: 12px;
      .container {
        max-width: 100%;
      }
      .tab-content {
        margin: 0 !important;
      }
    }
    .description-scroll {
      max-height: 100%;
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
  .candidate-picture {
    display: none !important;
  }
}

@media only screen and (max-width: 576px) {
  .hide-on-mobile {
    display: none !important;
  }
  .mobile-description-text {
    display: block !important;
    margin-top: 28px;
  }
  .header-title {
    width: 100%;
    padding: 25px 0 5px 6px;
    margin-bottom: 12px;

    &-name {
      font: 18px Montserrat;
      letter-spacing: 0;
      color: #000;
      flex: 1;
    }
    .single-job-controls {
      margin-left: 6px;
    }

    .name-edit {
      flex-shrink: 0;
    }
  }
  #description {
    padding: 0;
    overflow: hidden;
    .card {
      margin: 0 !important;
      min-height: auto;
      height: auto !important;
      padding-bottom: 70px;
      border-top-left-radius: 18px;
      border-top-right-radius: 18px;
      .req {
        min-height: 100vh;
      }
    }
    .tab-content {
      margin: 0;
    }
    .description-scroll {
      max-height: none;
    }
    .single-job-controls {
      margin-top: 20px;
      .select-style {
        position: relative;
        left: 0;
        max-width: 75%;
      }
      button {
        margin-left: auto !important;
      }
    }
    .mobile-only {
      display: block !important;
    }
  }
  .desktop-only {
    display: none;
  }
  .comments {
    padding: 8px;
  }
  .req-mobile {
    margin-top: 31px !important;
    display: none !important;
  }
  .header-title {
    display: block !important;
  }

  .desktop-pipelines {
    display: none !important;
  }

  .list-group-item {
    &.borderless {
      .d-flex {
        display: block !important;
        border-bottom: none !important;
        .icon-container {
          padding-left: 0 !important;
        }
      }
    }
  }
}

.tech-icons {
  margin-top: -30px;
  img {
    width: 30px;
    height: auto;
  }
}

.job-details {
  font-family: $font-family-sans-lato;
  font-size: 0.875rem;
  margin-top: 15px;

  li {
    display: inline-flex;
    .item-title {
      white-space: nowrap;
      font-weight: 700;
      margin-right: 20px;
    }

    .item-body {
    }
    &:nth-of-type(4) {
      .item-body {
        .tech-icons {
          margin-top: 0;
        }
      }
    }
  }
  .candidate-tag {
    border: 1px solid #a3a6b4;
    border-radius: 20px;
    color: #a3a6b4;
    padding: 6px 10px;
  }

  .candidate-tag-selected {
    color: $color-orange;
    border: 1px solid $color-orange;
  }

  .list-group {
    padding-left: 5px;
  }
  .tech-icons {
    position: relative;
    .show-more-icons {
      position: absolute;
      top: 123%;
      left: -5px;
      width: auto;
      max-width: 100%;
      background: #fff;
      border: 1px solid #ddd;
      z-index: 9;
      flex-wrap: wrap;
      .d-flex {
        padding: 12px 6px 6px 10px;
      }
      .icon-container {
        margin-right: 23px;
      }
    }
    .show-more-icons.second {
      left: -14px;
    }
    .collapsing {
      -webkit-transition: unset !important;
      transition: unset !important;
    }
  }
  .job-details {
    li {
      padding-left: 12px;
    }
  }
  /* Resetting utility class */
  .description-text {
    padding: 0 !important;
  }
}
</style>
